import { render, staticRenderFns } from "./TaskDetailDialog.vue?vue&type=template&id=f0c6937a"
import script from "./TaskDetailDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailDialog.vue?vue&type=style&index=0&id=f0c6937a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports